import * as React from 'react';

import { createStackNavigator } from '@react-navigation/stack';
import { getScreenOptions } from './getScreenOptions';
import MyProfileWearableSettingsScreen from '../screens/my-profile/MyProfileWearableSettingsScreen';
import MyDataListScreen from '../screens/my-data/MyDataListScreen';
import AppHeader from '../components/AppHeader';
import MyDataMeasurementDetailsScreen from '../screens/my-data/MyDataMeasurementDetailsScreen';
import {
  UserAttributeSource,
  UserAttributeType
} from '../models/UserAttribute';
import { RouteProp, useRoute } from '@react-navigation/core';
import { UserAttributesProvider } from '../context/UserAttributesContext';

export type MyDataParamList = {
  WearableIntegrationScreen: {
    disableAutoNavigate?: boolean;
  };
  MyDataListScreen: { isEmbedded?: boolean };
  MyDataMeasurementDetailsScreen: {
    source: UserAttributeSource;
    type: UserAttributeType;
    isEmbedded?: boolean;
  };
};

const MyDataStack = createStackNavigator<MyDataParamList>();

export default function MyDataNavigator() {
  const initialRoute = useRoute<RouteProp<any>>();
  const WearableIntegrationScreen: React.FC = () => (
    <MyProfileWearableSettingsScreen
      embedded={initialRoute.params?.isEmbedded}
      showTitle
      fromMyDataScreen
    />
  );
  return (
    <UserAttributesProvider embedded={initialRoute.params?.isEmbedded}>
      <MyDataStack.Navigator
        initialRouteName='WearableIntegrationScreen'
        screenOptions={({ route }) => ({
          ...getScreenOptions(route),
          header: () => <AppHeader />,
          headerShown: initialRoute.params?.isEmbedded ? false : true,
          headerMode: 'float',
          gestureEnabled: false
        })}
      >
        <MyDataStack.Screen
          name='WearableIntegrationScreen'
          component={WearableIntegrationScreen}
        />
        <MyDataStack.Screen
          name='MyDataListScreen'
          component={MyDataListScreen}
        />
        <MyDataStack.Screen
          name='MyDataMeasurementDetailsScreen'
          component={MyDataMeasurementDetailsScreen}
        />
      </MyDataStack.Navigator>
    </UserAttributesProvider>
  );
}
